import React, { Fragment, useState, useEffect, useContext, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';
import { Editor } from '@tinymce/tinymce-react';
import { BbIntegrate } from '../../../common/utils/bombbomb';
import Handlebars from 'handlebars/dist/cjs/handlebars'
import { jsPDF } from "jspdf";
import axios from 'axios';
import AWS from 'aws-sdk';
import ScheduleButton from '../ScheduleButton';
import { useDropzone } from 'react-dropzone';
import { createFile } from '../../../common/api';
import { storeMedia, createId, getExtensionFromMimeType, getMimeTypeFromExtension, storeEmailImage, extractImages, render } from '../../../common/utils';
import { toast } from 'react-toastify';
import { sendMassEmail, askGPT } from '../../../common/api';
import { MdContentCopy } from 'react-icons/md';


const SendMassEmail = ( { user, fromEmail, fromName, stack, close, contacts, contactEmails, opps, loans, globalStatus, loanStatus, clist, llist, objType, tmpl, tmplContent, aid, accts, team, rates } ) => {
    const [ to, setTo ] = useState( [] );
    const [ from, setFrom ] = useState( '' );
    const [ signature, setSignature ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ sendersLoaded, setSendersLoaded ] = useState( false );
    const [ subject, setSubject ] = useState( '' );
    const [ body, setBody ] = useState( '' );
    const [ bodyRendered, setBodyRendered ] = useState( '' );
    const [ attachments, setAttachments ] = useState( [] );
    const [ tmplUsed, setTmplUsed ] = useState( '' );
    const [ videoOption, setVideoOption ] = useState( false );
    const [ showVideo, setShowVideo ] = useState( false );
    const [ videoObj, setVideoObj ] = useState( {} );
    const [ loaded, setLoaded ] = useState( false );
    const [ sending, setSending ] = useState( false );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ showChatGPT, setShowChatGPT ] = useState( false );
    const [ prompt, setPrompt ] = useState( '' );
    const [ waiting, setWaiting ] = useState( false );
    const [ displayText, setDisplayText ] = useState( '' );
    const [ chatResp, setChatResp ] = useState( '' );
    const [ replace, setReplace ] = useState( false );
    const [ promptType, setPromptType ] = useState( 'freeform' );

    const editorRef = useRef( null );
    const tmplRef = useRef( null );
    tmplRef.current = allTmpls;
    const senderRef = useRef( null );
    senderRef.current = senderList;
    const bbObjRef = useRef( null );

    const switchSender = ( fromEmail ) => {
        const s = senderList.find( f => f.email === fromEmail );
        if ( s ) {
            setFrom( s.email );
            setSignature( s.signature );
        }
    };

    const formatRecip = useCallback( ( email ) => {
        const cid = contactEmails[email];
        let recip = { email: email };

        if ( cid ) {
            const c = contacts[cid];
            recip['cid'] = cid;

            if ( c.email && c.email.length && c.email.toLowerCase() === email ) {
                recip['name'] = c.firstname + ' ' + c.lastname;
            }
        }

        return recip;
    }, [ contacts, contactEmails ] );

    const onDrop = useCallback( acceptedFiles => {
        for ( let i = 0; i < acceptedFiles.length; i++ ) {
            const f = acceptedFiles[i];
            const reader = new FileReader();
            
            reader.onabort = () => {
                toast.success( `The upload process on ${f.path} has been aborted`, { theme: 'dark' } );
            }
            reader.onerror = () => {
                toast.success( `There's been an error while uploading ${f.path}`, { theme: 'dark' } );
            }
            reader.onload = async () => {
                const b = new Blob( [ reader.result ] );
                const ext = f.name.split( '.' )[1];
                let n = createId( 'file' );
                if ( ext ) {
                    n += '.' + ext;
                }
                
                const name = await storeMedia( user.aid, user.email, n, b, getMimeTypeFromExtension( ext ) );
                
                let file = {
                    mediaUrl: name,
                    name: f.name
                }
                
                await createFile( user.aid, user.email, file );

                setAttachments( prev => [
                    ...prev,
                    { name: file.name, fid: file.mediaUrl }
                ] );
                // toast.success( `Successfully uploaded ${f.name}`, { theme: 'dark' } );
                console.log( 'uploaded: ', name );
            }
            reader.readAsArrayBuffer( f );
        }
    }, [ user.aid, user.email ] );

    const { getRootProps, getInputProps, isDragActive } = useDropzone( { onDrop } );

    const removeAttachment = ( file ) => {
        setAttachments( prev => {
            const list = prev.filter( f => f.name !== file );
            return [ ...list ];
        } );
    }

    const insertAiResponse = () => {
        if ( replace ) {
            editorRef.current.selection.setContent( chatResp );
        } else {
            editorRef.current.insertContent( chatResp );
        }
        setReplace( false );
        setChatResp( '' );
        setDisplayText( '' );
        setShowChatGPT( false );
    };

    const insertAiSubject = ( sub ) => {
        setSubject( sub );
        setReplace( false );
        setChatResp( '' );
        setDisplayText( '' );
        setShowChatGPT( false );
    };

    const askAI = useCallback( async () => {
        setWaiting( true );
        const p = prompt;
        setPrompt( '' );
        
        const formattedTo = to.map( t => {
            return formatRecip( t.toLowerCase() );
        } );

        const sent = await askGPT( user.aid, user.email, prompt, promptType, formattedTo );
        setChatResp( sent );
        setWaiting( false );
    }, [ user.aid, user.email, prompt, promptType, to, formatRecip ] );

    const prepAskAI = async ( prompt, ptype ) => {
        setPromptType( ptype );
        setPrompt( prompt );
        setShowChatGPT( true );
        setReplace( true );
    };

    const handleEnter = async ( e ) => {
        if ( e.key === 'Enter' && !e.shiftKey ) {
            e.preventDefault();
            e.stopPropagation();
            await askAI();        
        }
    };

    const displayContactName = ( cid ) => {
        let name = 'Unknown Name';
        const c = contacts[cid];
        if ( c ) {
            name = c.preferredName || c.firstname;
            if ( c.lastname ) {
                name += ( name?.length ) ? ' ' : '';
                name += c.lastname;
            }
            if ( !name?.length ) {
                name = c.email;
            }
        }
        return name;
    };

    const displayLoanNames = ( lid ) => {
        let name = 'Unknown Name';
        const l = loans[lid];
        if ( l && l.borrowers && l.borrowers.length ) {
            const pri = l.borrowers.find( f => f.label === 'Primary' ) || l.borrowers[0];
            const c = contacts[pri?.cid];
            if ( c ) {
                name = c.preferredName || c.firstname;
                if ( c.lastname ) {
                    name += ( name.length ) ? ' ' : '';
                    name += c.lastname;
                }
                if ( !name.length ) {
                    name = c.email;
                }
            }
        }
        return name;
    };

    const displayTypingEffect = useCallback( () => {
        let index = 0;
    
        if ( promptType !== 'subject-line-reco' ) {
            setDisplayText( chatResp );
            // Use setInterval to update the displayText over time
            // const interval = setInterval(() => {
            // if (index < chatResp.length) {
            //     setDisplayText( chatResp.substring( 0, index ) );
            //     index++;
            // } else {
            //     clearInterval(interval); // Stop the interval when done
            // }
            // }, 10 ); // Adjust the timing for the desired typing speed
        } else {
            const matches = chatResp.match( /Var1: "(.*?)"\nVar2: "(.*?)"\nVar3: "(.*)"/ );
            if ( matches ) {
                let resp = <ol>{ matches.map( ( sub, i ) => {
                    if ( i === 0 ) {
                        return null;
                    }
                    return <li>{sub} <Button variant='link' className='ms-2 p-0 tf-copy-button' onClick={ () => insertAiSubject( sub ) }><MdContentCopy /></Button></li>
                } )}</ol>;

                console.log( 'setting matches: ' + resp );
                setDisplayText( resp );
            } else {
                setDisplayText( chatResp );
            }
        }
    }, [ chatResp, promptType ] );

    const insertText = ( txt ) => {
        // const loc = editor.getSelection( true );
        // editor.insertText( loc.index, txt );
    }

    const insertVideo = useCallback( ( l, i ) => {
        const v = `<a href="${l}"><img src="${i}" /></a>`;
        editorRef.current.insertContent( v );
    }, [ editorRef ] );

    const bbCallback = useCallback( ( video ) => {
        setShowVideo( false );
        bbObjRef.current.removeIframe();
        insertVideo( video.link, video.thumbnail );
    }, [ insertVideo ] );

    const bbRef = useCallback( ( r ) => {
        if ( r ) {
            bbObjRef.current.embedIframe( r );
        }
    }, [ bbObjRef ] );

    const createPdf = async () => {
        const pdf = new jsPDF( {
            orientation: 'p',
            unit: 'px',
            hotfixes: [ 'px_scaling' ],
            format: 'letter',
            putOnlyUsedFonts: true
        } );
        
        let styledBody = body.replace( /<p>/g, '<p style="font-size: 12px; margin-bottom: 0 !important; padding-bottom: 0 !important; border: 1px solid #000; font-family: Calibri, sans-serif;">' );
        
        const imgSearch = /<img .*?src=['"](.*?)['"]/g;
        let imgSrc;
        while ( ( imgSrc = imgSearch.exec( styledBody ) ) !== null ) {
            if ( imgSrc[1].match( /^http/ ) ) {
                const resp = await axios.get( imgSrc[1], { responseType: 'arraybuffer' } );
                console.log( resp );
                let img64 = Buffer.from( resp.data, 'binary' ).toString( 'base64' );
            } else {
                console.log( 'skipping tag since it is not http: ', imgSrc );
            }
        }
        console.log( styledBody );
        pdf.html( `<div style="width:100%;">${styledBody}</div>`, {
            callback: () => {
                pdf.save( 'TFv8.pdf' );
            },
            x: 20,
            y: 20,
            autoPaging: 'text',
            width: 780,
            windowWidth: 780
        } );
    };

    const loadPromptContextSubMenu = ( editor ) => {
        return [
            {
                type: 'item',
                text: 'Summarize',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'summarize' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: "item",
                text: 'Explain',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'explain' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Improve Writing',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'improve-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Simplify Writing',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'simplify-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Overcome Objection',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'objection-handler' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Check Guideline Accuracy',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'guideline-accuracy' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        // buttonApi.setEnabled( selectedText );
                    };
                    buttonApi.setEnabled( false );
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            }
        ]
    }

    const loadPromptContextMenu = ( editor ) => {
        return [
            {
                type: 'submenu',
                text: 'MortgageGPT',
                icon: 'ai',
                getSubmenuItems: () => {
                    const selectedText = editor.selection.getContent( { format: 'text' } );
                    return selectedText ? loadPromptContextSubMenu( editor ) : ''; // Show submenu items if text is selected
                },
            }
        ]
    }

    const loadPromptMenu = ( editor ) => {
        return [ 
            {
                type: 'menuitem',
                text: 'Overcome Objections',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'objection-handler' );
                }
            }, 
            {
                type: 'menuitem',
                text: 'Check Guideline Accuracy',
                enabled: false,
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'guideline-accuracy' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Suggest a Subject Line',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'subject-line-reco' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Summarize',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'summarize' );
                }
            },
            {
                type: 'menuitem',
                text: 'Explain',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'explain' );
                }
            },
            {
                type: 'menuitem',
                text: 'Improve Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'improve-writing' );
                }
            },
            {
                type: 'menuitem',
                text: 'Simplify Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'simplify-writing' );
                }
            }
        ]
    }

    const loadTemplates = ( editor ) => {
        let list = [];
        
        // console.log( 'load templates: ', tmplRef.current );
        if ( Object.keys( tmplRef.current ).length ) {
            Object.keys( tmplRef.current ).sort().forEach( name => {
                const t = tmplRef.current[name];

                if ( !t.objects || t.objects.includes( 'mass' ) ) {
                    const content = t.body;
                    let fresh = false;
                    let sig = '';

                    list.push( {
                        type: 'menuitem',
                        text: t.name,
                        onAction: () => {
                            if ( t.from ) {
                                const s = senderRef.current.find( f => f.email === t.from );
                                if ( s ) {
                                    setFrom( t.from );
                                    sig = s.signature;
                                    fresh = true;
                                }
                            }
                            if ( t.subject ) {
                                setSubject( t.subject );
                            }

                            if ( fresh ) {
                                editor.setContent( content + '<br /><br />' + sig );
                            } else {
                                editor.insertContent( content );
                            }
                            
                            setTmplUsed( t.tid );
                        }
                    } );
                }
            } );
        }
        if ( user.signature && user.signature.length ) {
            list.push( {
                type: 'menuitem',
                text: 'Signature',
                onAction: () => editor.insertContent( user.signature )
            } );
        }
        
        return ( list );
    }

    const send = async ( d, t, tz ) => {
        setSending( true );

        const e = editorRef.current.getContent();
        const body = await extractImages( aid || user.aid, user.email, e );
        // const formattedFrom = { name: fromName, email: fromEmail };
        const f = senderList.find( f => f.email === from );
        const formattedFrom = { email: f.email, name: f.name };

        console.log( 'Sending email:', aid || user.aid, formattedFrom, subject, clist, llist );
        
        let msg = {
            subject: subject,
            from: formattedFrom,
            body: body, // e,
            tmpl: tmplUsed,
            attachments: attachments,
            date: d,
            time: t,
            tz: tz,
            channel: 'email'
        };

        if ( objType === 'loan' ) {
            msg['loans'] = llist;
        } else if ( objType === 'contact' ) {
            msg['contacts'] = clist;
        }

        const sent = await sendMassEmail( aid || user.aid, user.email, msg );
        // if ( sent.length ) {
            setSending( false );
            toast.success( `The Email has been Sent`, { theme: 'dark' } );
            close();
        // }
        // console.log( sent );
    };

    const displayVideo = () => { setShowVideo( true ); }
    
    const renderPreview = ( obj ) => {
        const a = accts.find( f => f.id === obj.aid );
        const owner = ( a ) ? team.find( f => f.email === a.owner ) : user;

        const e = editorRef.current.getContent();
        const styledBody = e.replace( /<p>/g, '<p style="font-size: 12px; font-family: Calibri, sans-serif; margin-bottom: 0 !important;">' );
        let params = {
            user: user,
            owner: owner,
            rates: rates,
            account: a
        };

        if ( objType === 'contact' ) {
            const refs = [];

            if ( obj.priRole === 'partner' ) {
                obj['activeLeads'] = false;
                obj['activePAs'] = false;
                obj['activeLoans'] = false;

                Object.keys( contacts ).forEach( cid => {
                    const c = contacts[cid];
                    if ( c.referredById === obj.cid ) {
                        console.log( c.name + ' is referred by ' + obj.name );
                        const los = [];
                        const ls = [];

                        Object.keys( opps ).forEach( o => {
                            const lo = opps[o];
                            if ( lo.relationships?.find( f => f.cid === c.cid ) ) {
                                const q = globalStatus.find( f => f.value === lo.status );

                                if ( [ 'lead', 'talking', 'app-sent', 'setup', 'review' ].includes( q?.queue ) ) {
                                    obj['activeLeads'] = true;
                                    lo['queue'] = 'lead';
                                    los.push( lo );
                                }
                            }
                        } );

                        Object.keys( loans ).forEach( lid => {
                            const l = loans[lid];
                            if ( l.borrowers?.find( f => f.cid === c.cid ) ) {
                                const q = loanStatus.find( f => f.value === l.status );

                                if ( q?.queue === 'pa' ) {
                                    obj['activePAs'] = true;
                                    l['queue'] = 'pa';
                                    ls.push( l );
                                }

                                if ( q?.queue === 'active' ) {
                                    obj['activeLoans'] = true;
                                    l['queue'] = 'active';
                                    ls.push( l );
                                }
                            }
                        } );

                        refs.push( {
                            ...c,
                            opps: los,
                            loans: ls
                        } );
                    }
                } );
            }

            params['contact'] = {
                ...obj,
                referredBy: contacts[obj.referredById],
                referrals: refs
            };
        } else if ( objType === 'loan' ) {
            const pri = obj.borrowers.find( f => f.label === 'Primary' ) || obj.borrowers[0];
            const c = contacts[pri.cid];
            const lp2 = user.lists.team.find( f => f.uid === obj.lp2 );
            params['contact'] = {
                ...c,
                referredBy: contacts[c.referredById]
            };
            params['loan'] = {
                ...obj,
                buyersAgent: contacts[obj.baId],
                buyersAgentTC: contacts[obj.baTcId],
                listingAgent: contacts[obj.laId],
                listingAgentTC: contacts[obj.laTcId],
                escrow: contacts[obj.escrowOfficerId],
                title: contacts[obj.titleRepId],
                lp2rep: lp2
            };
        }
        setBodyRendered( render( styledBody, params, contacts ) );
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };
    
    useEffect( () => {
        if ( chatResp.length ) {
            displayTypingEffect();
        }
    }, [ chatResp, displayTypingEffect ] );

    useEffect( () => {
        if ( clist?.length && !loaded ) {
            setLoaded( true );
            setTo( clist );
        }
    }, [ clist, loaded ] );

    useEffect( () => {
        if ( user.stack && user.stack.video ) {
            switch ( user.stack.video.type ) {
                case 'BombBomb':
                    if ( window.BbIntegrate ) {
                        const bb = new window.BbIntegrate( 'd4efd0d8-d20b-490c-0fc1-16f0424ba2e9', { onVideo: bbCallback } );
                        bbObjRef.current = bb;
                        // setVideoObj( bb );
                        setVideoOption( true );
                    }
                    break;

                default:
            }
        }
    }, [ user.stack, editorRef, bbCallback ] );

    useEffect( () => {
        let temps = {};

        if ( user.meta.templates && user.meta.templates.length ) {
            user.meta.templates.forEach( t => {
                temps[t.name] = t;
            } );
        }
        if ( user.templates && user.templates.length ) {
            user.templates.forEach( t => {
                temps[t.name] = t;
            } );
        }

        setAllTmpls( temps );
    }, [ user.templates, user.meta.templates ] );

    useEffect( () => {
        if ( tmplContent && tmplContent.length ) {
            setBody( tmplContent );
        } else if ( tmpl ) {
            let t;
            let sig = signature;

            if ( user.templates && user.templates.length ) {
                t = user.templates.find( f => f.tid === tmpl );
            }

            if ( !t ) {
                const a = accts.find( f => f.id === aid );
                if ( a && a.crm && a.crm.meta.templates && a.crm.meta.templates.length ) {
                    t = a.crm.meta.templates.find( f => f.tid === tmpl );
                }
            }

            if ( t ) {
                if ( t.from ) {
                    const s = senderList.find( f => f.email === t.from );
                    const tm = team.find( f => f.email === t.from );
                    if ( s ) {
                        setFrom( t.from );
                        if ( s.signature && s.signature.length ) {
                            sig = s.signature;
                        } else if ( tm && tm.signature && tm.signature.length ) {
                            sig = tm.signature;
                        } else if ( user.signature && user.signature.length ) {
                            sig = user.signature;
                        }
                    }
                }
                if ( t.attachments ) {
                    setAttachments( t.attachments );
                }

                setSubject( t.subject );

                if ( t.removeSig === true ) {
                    setBody( t.body );
                } else {
                    setBody( t.body + sig );
                }

                setTmplUsed( t.tid );
            }
        } else if ( signature && signature.length ) {
            setBody( '<br /><br />' + signature );
        }
    }, [ tmplContent, tmpl, user.aid, signature, user.templates, user.meta.templates, user.signature, senderList, accts, team, aid ] );

    useEffect( () => {
        if ( user && !sendersLoaded ) {
            setFrom( user.email );
            setSignature( user.signature );

            let list = [ {
                email: user.email,
                name: user.name,
                signature: user.signature
            } ];

            if ( user.additionalEmailSenders && user.additionalEmailSenders.length ) {
                user.additionalEmailSenders.forEach( s => {
                    if ( !s.signature ) {
                        const tm = team.find( f => f.email === s.email );
                        if ( tm && tm.signature ) {
                            s.signature = tm.signature;
                        }
                    }

                    if ( aid === s.aid && s.default !== false ) {
                        console.log( 'aid matches additional email sender aid: ', s );
                        setFrom( s.email );
                        setSignature( s.signature );
                    }
                    list.push( s );
                } );
            }
            
            setSenderList( list );
            setSendersLoaded( true );
        }
    }, [ user, sendersLoaded ] );

    useEffect( () => {
        if ( replace && prompt.length ) {
            askAI();
        }
    }, [ replace, prompt, askAI ] );
    
    return (
        <Fragment>
            <Box sx={style}>
                <Container fluid className=''>
                    <Row className='pt-2 pb-3 align-items-center tf-email-header-row'>
                        <Col xs='auto' className='tf-email-header-name'>From</Col>
                        {
                            ( senderList.length === 1 ) ? (
                                <Col className='tf-email-header-value'>{user.email}</Col>
                            ) : (
                                <Col xs='auto' className='tf-email-header-value tf-form-select-field me-1'>
                                    <Form.Select size='sm' className='tf-modal-select-input' value={from} onChange={ ( e ) => switchSender( e.target.value ) }>
                                        {
                                            senderList.map( ( s, idx ) => <option key={idx} value={s.email}>{s.email}</option> )
                                        }
                                    </Form.Select>
                                </Col>
                            )
                        }
                    </Row>
                    <Row className='py-3 align-items-center'>
                        <Col xs='auto' className='tf-email-header-name'>Subject</Col>
                        <Col className='tf-form-text-field ps-0'><Form.Control value={subject} className='px-0' onChange={ ( e ) => setSubject( e.target.value ) } /></Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Tabs defaultActiveKey='content'>
                        <Tab eventKey='content' title='Content'>
                                <Editor
                                    tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                    init={ { 
                                        menubar: false, 
                                        statusbar: false,
                                        toolbar_mode: 'wrap',
                                        visual: false,
                                        content_style: 'body { font-family:Arial; font-size:12pt }',
                                        setup: ( editor ) => {
                                            editor.ui.registry.addButton( 'tfvideo', {
                                                icon: 'embed',
                                                tooltip: 'Insert Video',
                                                enabled: true,
                                                onAction: (_) => {
                                                    setShowVideo( true );
                                                },
                                            } );
                                            editor.ui.registry.addMenuButton( 'tftmpl', {
                                                text: 'Insert Template...',
                                                fetch: ( cb ) => {
                                                    const items = loadTemplates( editor );
                                                    cb( items );
                                                }
                                            } );
                                            editor.ui.registry.addMenuButton( 'tfaiprompts', {
                                                icon: 'ai-prompt',
                                                fetch: ( cb ) => {
                                                const items = loadPromptMenu();
                                                cb( items );
                                                }
                                            } );
                                            editor.ui.registry.addButton( 'tfchatgpt', {
                                                icon: 'ai',
                                                tooltip: 'Ask MortgageGPT',
                                                onAction: () => {
                                                    setShowChatGPT( true );
                                                }
                                            });
                                            
                                            editor.ui.registry.addContextMenu( 'aiContextMenu', {
                                                update: ( element ) => {
                                                    const selectedText = editor.selection.getContent( { format: 'text' } );
                                                    return selectedText ? loadPromptContextMenu( editor ) : ''; // Show the custom item if text is selected
                                                },
                                            } );
                                        },
                                        browser_spellcheck: true,
                                        contextmenu: 'aiContextMenu link',
                                        paste_preprocess: (plugin, args) => {
                                            const tempDiv = document.createElement('div');
                                            tempDiv.innerHTML = args.content;
                                            tempDiv.querySelectorAll('[data-editing-info]').forEach((el) => {
                                              el.removeAttribute('data-editing-info');
                                            });
                                            args.content = tempDiv.innerHTML;
                                        }
                                    } }
                                    onInit={ ( evt, editor ) => {
                                        editorRef.current = editor;
                                    } }
                                    initialValue={body}
                                    plugins='emoticons code lists link image'
                                    toolbar='fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | align bullist numlist | link | image tfvideo emoticons tftmpl tfchatgpt tfaiprompts | code'
                                />
                        </Tab>
                        <Tab eventKey='preview' title='Preview'>
                            <Container fluid className='px-0'>
                                <Row className='tf-email-editor-container me-0' style={ { height: '400px' } }>
                                    <Col xs={3} className='overflow-auto' style={ { borderRight: '1px solid #CCC', maxHeight: '400px', overflowY: 'auto' } }>
                                        {
                                            clist && clist.length ? clist.map( cid => {
                                                return (
                                                    <Row key={cid}>
                                                        <Col><Button size='sm' variant='link' onClick={ () => renderPreview( contacts[cid] ) }>{displayContactName( cid )}</Button></Col>
                                                    </Row>
                                                )
                                            } ) : null
                                        }
                                        {
                                            llist && llist.length ? llist.map( lid => {
                                                return (
                                                    <Row key={lid}>
                                                        <Col><Button size='sm' variant='link' onClick={ () => renderPreview( loans[lid] ) }>{displayLoanNames( lid )}</Button></Col>
                                                    </Row>
                                                )
                                            } ) : null
                                        }
                                    </Col>
                                    <Col xs={9} className='overflow-scroll pt-2' style={ { maxHeight: '400px' } }>
                                        <div dangerouslySetInnerHTML={ { __html: bodyRendered } } />
                                    </Col>
                                </Row>
                            </Container>
                        </Tab>
                    </Tabs>
                </Container>
                {
                    attachments.length ? (
                        <Container fluid className='pe-0'>
                            <Row className='w-100 py-2 me-0'>
                                { attachments.map( a => <Col key={a.name} xs='auto'><span className='tf-email-attachment-file'>{a.name}</span><span className='tf-email-attachment-delete' onClick={ () => removeAttachment( a.name ) }>X</span></Col>) }
                            </Row>
                        </Container>
                    ) : (
                        null
                    )
                }
                <Container fluid className='pe-0'>
                    <Row className='w-100 py-2 me-0 align-items-center'>
                        <Col className='p-2 text-center' { ...getRootProps() } style={ { color: 'var( --tf-blue )', fontWeight: 600, border: '1px dotted var( --tf-blue )' } }>
                            <input { ...getInputProps() } />
                            <Row><Col>Drop Attachments or <Button variant='outline-primary' size='sm'>Select Files</Button></Col></Row>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className='w-100 p-2 align-items-center'>
                        <Col className='pe-2 text-end'><ScheduleButton send={send} disabled={!subject.length || sending} /></Col>
                        <Col className='ps-2 text-start'><Button variant='outline-dark' onClick={close}>Cancel</Button></Col>
                    </Row>
                    {
                        ( !subject.length ) ? (
                            <Row className='w-100 p-2 align-items-center text-center'>
                                <Col style={ { color: 'red' } }>* Subject is Required</Col>
                            </Row>
                        ) : (
                            null
                        )
                    }
                </Container>
            </Box>
            <Modal open={showVideo} onClose={ () => setShowVideo( false ) }>
                <Box sx={ { ...style, width: '820px' } } id='tf-bbv-container' ref={bbRef} />
            </Modal>
            <Modal open={showChatGPT} onClose={ () => setShowChatGPT( false ) }>
                    <Box 
                        id='tf-chatgpt-container'
                        sx={ {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '50%',
                            height: 500,
                            bgcolor: 'background.paper',
                            border: '2px solid #000',
                            boxShadow: 24,
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                        } }
                    >
                        <Button
                            variant="outline"
                            onClick={ () => setShowChatGPT( false ) }
                            style={ { position: 'absolute', top: '5px', right: '5px' } }
                        >
                            X
                        </Button>
                        <Typography variant="h5" id="modal-title">
                            AI Assistant
                        </Typography>
                        {
                            ( waiting ) ? (
                                <div style={ { height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
                                    <Spinner animation='border' />
                                </div>
                            ) : (
                                <Box sx={{ overflowY: 'auto', flex: 1, paddingTop: '20px' }}>
                                    {
                                        ( promptType !== 'subject-line-reco' ) ? (
                                            <div dangerouslySetInnerHTML={ { __html: displayText } } />
                                        ) : (
                                            displayText
                                        )
                                    }
                                </Box>
                            )
                        }
                        { chatResp && (
                            <Row className='w-100 p-2 align-items-center'>
                                <Col className='pe-2 text-end'><Button variant='outline-dark' color='primary' onClick={insertAiResponse}>Insert</Button></Col>
                                <Col className='ps-2 text-start'><Button variant='outline-dark' color='primary' onClick={ () => alert( 'try again' ) }>Try Again</Button></Col>
                            </Row>
                        ) }
                        <TextField 
                            id="chat-prompt" 
                            label="Send a message" 
                            multiline 
                            minRows={1} 
                            maxRows={5} 
                            value={prompt}
                            onChange={ ( e ) => { setPrompt( e.target.value ) } }
                            onKeyDown={ ( e ) => handleEnter( e ) }
                            variant="outlined" 
                            sx={ {
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                                    padding: '16.5px 14px'
                                },
                            } }
                            InputProps={ {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton edge="end" onClick={ () => askAI() }>
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            } }
                            fullWidth
                        />
                    </Box>
                </Modal>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    accts: state.user.lists.accounts,
    team: state.user.lists.team,
    fromEmail: state.user.email,
    fromName: state.user.name,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    contactEmails: state.contacts.byEmail,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
    globalStatus: state.user.meta.global.picklist.status,
    loanStatus: state.user.meta.loan.picklist.status,
    rates: state.user.rates,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( SendMassEmail );